<div class="bulk-creator">
    <div class="file-upload-section">
        <span class="file-upload-label">
            Seleccione un archivo CSV <mat-icon matTooltip="El archivo debe estar en formato CSV, la primera fila debe contener el nombre de las columnas.">info</mat-icon>
        </span>
        <input type="file" (change)="onFileSelection($event)" />
    </div>
    <div class="column-matcher-section" *ngIf="parsingFile || fields">
        <span class="section-title">
            Mapeo de columnas <mat-icon matTooltip="Seleccione para cada dato requerido, el nombre de la columna en el archivo seleccionado.">info</mat-icon>
        </span>
        <span class="message" *ngIf="parsingFile">
            Procesando archivo...
        </span>
        <div class="column-matcher" *ngIf="fields && !parsingFile">
            <div class="column-match" *ngFor="let column of columnMaps">
                <span class="column-name">{{ column.description }}:</span>
                <mat-form-field class="garantor-form-field no-bottom-spacing-form-field" appearance="outline">
                    <mat-label>Columna del CSV</mat-label>
                    <mat-select [(ngModel)]="column.fieldName" (ngModelChange)="updateErrors()">
                        <mat-option> - </mat-option>
                        <mat-option *ngFor="let option of getUnusedFields(column)" [value]="option">
                            {{ option }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="data-editor-section" *ngIf="data">
        <span class="section-title">
            Verificación de campos
        </span>
        <app-data-table
            [rows]="data"
            [columns]="getDataEditorColumns()"
            [stickyHeader]="true"
            stickyHeaderBackground="#f8f8f8"
            maxHeight="450px"
            maxWidth="calc(100vw - 380px)"
            overflow="auto"
        ></app-data-table>
    </div>
    <button mat-raised-button class="garantor-button submit-button" color="primary" *ngIf="data" [disabled]="!availableToSubmit()" (click)="runSubmit()">
        Ejecutar carga masiva
    </button>
</div>

<ng-template #fieldEditionColumnTemplate let-rowIndex="rowIndex" let-row="row" let-params="params">
    <mat-form-field class="garantor-form-field no-bottom-spacing-form-field no-label" appearance="outline">
        <input matInput [(ngModel)]="data[rowIndex][params.fieldName]" (ngModelChange)="updateErrors(row, rowIndex)" />
    </mat-form-field>
</ng-template>

<ng-template #deleteRowColumnTemplate let-rowIndex="rowIndex">
    <button mat-icon-button class="delete-button" (click)="deleteRow(rowIndex)">
        <mat-icon>delete</mat-icon>
    </button>
</ng-template>
